// extracted by mini-css-extract-plugin
module.exports = {"bg":"_3dnSo","inlineContent":"_3Swm9","pageWrapper":"_2Vn0y","shadow":"_3GGCU","leftBottom":"_3zaSy","rightBottom":"dsVKJ","centerBottom":"_1q2Pu","innerBg":"_2GAPG"};